export const messages = (lang) => {
  const strings = {
    fi: {
      SUBMIT_LABEL: 'Näytä asunnot ({amount})',
      TAB_1: 'Asumisoikeusasunnot',
      TAB_2: 'Vuokra-asunnot',
      TAB_3: 'Etsitkö omistusasuntoa?',
      MULTISELECT_LABEL: 'Sijainti',
      MULTISELECT_PLACEHOLDER:
        'Kaupunki, kaupunginosa, postinumero, katuosoite',
      AREA_LABEL: 'Pinta-ala',
      USAGE_FEE_MAX_LABEL: 'Käyttövastike enintään',
      RENT_FEE_MAX_LABEL: 'Vuokra enintään',
      EURO_MONTH: '€ / kk',
      BUILDING_TYPE_LABEL: 'Talotyyppi',
      ROOMS_LABEL: 'Huoneita',
      DETAILED_SEARCH_LABEL: 'Tarkenna hakua',
      TOGGLE_MORE: 'Lisää hakuehtoja',
      TOGGLE_LESS: 'Vähemmän hakuehtoja',
      AVAILABLE_LATEST: 'Vapautuu viimeistään',
      FOUND_AVAILABLE_TITLE: 'Löytyi {amount} vapaata tai vapautuvaa asuntoa',
      FOUND_AVAILABLE_TITLE_CITY:
        'Alueelta {city} löytyi {amount} vapaata tai vapautuvaa asuntoa',
      SORT_PLACEHOLDER: 'Järjestä',
      SORT_BY_OPTION_1: 'Pienin ensin',
      SORT_BY_OPTION_2: 'Suurin ensin',
      SORT_BY_OPTION_3: 'Edullisin ensin',
      SORT_BY_OPTION_4: 'Kallein ensin',
      SORT_BY_OPTION_5: 'Edullisin käyttövastike',
      FOUND_UNIT_RESULTS_TITLE:
        '{amountApartments} haettavaa asuntoa {amountUnits} kohteessa',
      FOUND_UNIT_RESULTS_DESCRIPTION:
        'Hakuasi vastaavat kohteet, joissa ei mahdollisesti ole juuri nyt vapaita asuntoja, mutta joihin voit tehdä asuntohakemuksen. Hakemukselle kannattaa valita myös taloja, joissa ei juuri nyt ole vapaita asuntoja. Silloin olet mukana hakuprosessissa, kun asuntoja vapautuu tarjottavaksi.',
      APARTMENT_VALUES_LABEL_1: 'Käyttövastike / kk',
      APARTMENT_VALUES_LABEL_1_RENT: 'Vuokra / kk',
      APARTMENT_VALUES_LABEL_2: 'Asumisoikeusmaksu',
      APARTMENT_VALUES_LABEL_2_RENT: 'Varallisuusrajat',
      APARTMENT_VALUES_LABEL_3_RENT: 'Tulorajat',
      APARTMENT_VALUES_LABEL_3: 'Rakennusvuosi',
      APARTMENT_VALUES_LABEL_4: 'Kerros',
      APARTMENT_VALUES_LABEL_5: 'Vapautuu',
      APARTMENT_VALUES_LABEL_6: 'Seuraava näyttö',
      APARTMENT_STATUS_LABEL: 'Uudiskohde',
      APARTMENT_AVAILABLE_LABEL: 'Heti vapaa',
      APARTMENT_AVAILABLE_UNKNOWN: 'Tarkentuu myöhemmin',
      APARTMENT_NEW_AND_AVAILABLE: 'Uudiskohde, heti vapaa',
      APARTMENT_NEW_AND_IN_CONSTRUCTION: 'Uudiskohde, rakenteilla',
      APARTMENT_RENOVATED_AND_AVAILABLE: 'Peruskorjattu, heti vapaa',
      APARTMENT_RENOVATED: 'Peruskorjattu',
      APARTMENT_IS_PLANNED: 'Uudiskohde, tulossa hakuun myöhemmin',
      APARTMENT_MORE_LINK_LABEL: 'Katso tarkemmat tiedot',
      APARTMENT_ADD_LABEL: 'Lisää hakemukseen',
      APARTMENT_REMOVE_LABEL: 'Poista hakemukseltasi',
      LOAD_MORE: 'Lisää asuntoja',
      UNIT_VALUES_LABEL_1: 'Käyttövastike / kk',
      UNIT_VALUES_LABEL_2: 'Asumisoikeusmaksu keskim.',
      UNIT_VALUES_LABEL_3: 'Arvioitu valmistumisaika',
      UNIT_VALUES_LABEL_1_RENT: 'Vuokra',
      UNIT_TEXT_INFO:
        'Voit jättää hakemuksen, vaikka talossa ei olisi nyt vapaita asuntoja.',
      UNIT_MORE_BUTTON_LABEL:
        'Tutustu taloon ja lisää haluamasi asuntotyypit hakemukselle',
      UNIT_MORE_BUTTON_ARIA_LABEL:
        'Tutustu taloon {address} ja lisää haluamasi asuntotyypit hakemukselle',
      UNIT_PLANNED_BUTTON_LABEL:
        'Katso tarkemmat tiedot ja liity postituslistalle',
      YES: 'Kyllä',
      NO: 'Ei',
      RENT_CHECKBOX_LABEL:
        'Näytä vain varallisuus- ja tulorajoitetut vuokra-asunnot.',
      EXTRA_INFO_1: 'Hinnat ovat toistaiseksi arvioita.',
      EXTRA_INFO_2:
        'Tämä on tulossa oleva uudiskohde, jonka hakuaika alkaa myöhemmin. Liity uudiskohteen postituslistalle kohteen sivuilta, jolloin saat tiedon, kun hakuaika alkaa.',
      GO_TO_APPLICATION_LABEL: 'Siirry hakemukseesi',
      READ_MORE: 'Lue lisää',
      ZERO_RESULTS:
        'Haullasi ei juuri nyt löytynyt koteja, jotka olisivat tällä hetkellä vapaana tai vapautumassa.',
      SEARCH_BUTTON_TITLE:
        'Asuntojen hakupainike on epäaktiivinen, kunnes olet tehnyt jonkin valinnan asuntohaussa.',
      KERROSTALO: 'Kerrostalo',
      RIVITALO: 'Rivitalo',
      OMAKOTITALO: 'Omakotitalo',
      PARITALO: 'Paritalo',
      ERILLISTALO: 'Erillistalo',
      ERILLISPIENTALO: 'Erillispientalo',
      LUHTIKYTVTALO: 'Luhtikäytävätalo',
      PIENKERROSTALO: 'Pienkerrostalo',
      CALL_NOW: 'Soita nyt',
    },
    sv: {
      SUBMIT_LABEL: 'Show homes ({amount})',
      TAB_1: 'Right-of-occupancy homes',
      TAB_2: 'Rental homes',
      TAB_3: 'Owner-occupied homes',
      MULTISELECT_LABEL: 'Location',
      MULTISELECT_PLACEHOLDER: 'City, district, postal code, address',
      AREA_LABEL: 'Yta',
      USAGE_FEE_MAX_LABEL: 'Residence charge max',
      RENT_FEE_MAX_LABEL: 'Rent max',
      EURO_MONTH: '€ / mån',
      BUILDING_TYPE_LABEL: 'Hustyp',
      ROOMS_LABEL: 'Rooms',
      DETAILED_SEARCH_LABEL: 'Features',
      TOGGLE_MORE: 'More search rules',
      TOGGLE_LESS: 'Less search rules',
      AVAILABLE_LATEST: 'Available latest',
      FOUND_AVAILABLE_TITLE:
        '{amount} available or soon to be available homes found.',
      FOUND_AVAILABLE_TITLE_CITY:
        '{amount} available or soon to be available homes found in {city}.',
      SORT_PLACEHOLDER: 'Sort by',
      SORT_BY_OPTION_1: 'Smallest first',
      SORT_BY_OPTION_2: 'Largest first',
      SORT_BY_OPTION_3: 'Least expensive first',
      SORT_BY_OPTION_4: 'Most expensive first',
      SORT_BY_OPTION_5: 'Lowest residence charge/month',
      FOUND_UNIT_RESULTS_TITLE:
        '{amountApartments} matching homes in {amountUnits} houses',
      FOUND_UNIT_RESULTS_DESCRIPTION:
        'These buildings are matching to your search criteria, but there may not be available homes at the moment. However, you can also add buildings with no available homes to your application, and when apartments that match your application become available, you will be automatically included in the application process for the following types of home.',
      APARTMENT_VALUES_LABEL_1: 'Maximivederlag / mån',
      APARTMENT_VALUES_LABEL_1_RENT: 'Hyra / mån',
      APARTMENT_VALUES_LABEL_2: 'Överlåtelsepris',
      APARTMENT_VALUES_LABEL_2_RENT: 'Asset limits',
      APARTMENT_VALUES_LABEL_3_RENT: 'Income limits',
      APARTMENT_VALUES_LABEL_3: 'Året för färdigställande',
      APARTMENT_VALUES_LABEL_4: 'Våning',
      APARTMENT_VALUES_LABEL_5: 'Blir ledig',
      APARTMENT_VALUES_LABEL_6: 'Next viewing',
      APARTMENT_STATUS_LABEL: 'New property',
      APARTMENT_AVAILABLE_LABEL: 'Genast ledig',
      APARTMENT_AVAILABLE_UNKNOWN: 'Specified later',
      APARTMENT_NEW_AND_AVAILABLE: 'New property, available now',
      APARTMENT_NEW_AND_IN_CONSTRUCTION: 'New property, under construction',
      APARTMENT_RENOVATED_AND_AVAILABLE: 'Renovated, available now',
      APARTMENT_RENOVATED: 'Grundrenoverad',
      APARTMENT_IS_PLANNED: 'New property, coming soon',
      APARTMENT_MORE_LINK_LABEL: 'More details',
      APARTMENT_ADD_LABEL: 'Add to application',
      APARTMENT_REMOVE_LABEL: 'Ta bort från din ansökan',
      LOAD_MORE: 'More homes',
      UNIT_VALUES_LABEL_1: 'Bruksvederlag / mån',
      UNIT_VALUES_LABEL_2: 'Right-of-occupancy payment (avg.)',
      UNIT_VALUES_LABEL_3: 'Estimated time of completion',
      UNIT_VALUES_LABEL_1_RENT: 'Hyra',
      UNIT_TEXT_INFO:
        'You can also add homes to your application, which are not available at the moment.',
      UNIT_MORE_BUTTON_LABEL: 'Learn more and add homes to application',
      UNIT_MORE_BUTTON_ARIA_LABEL: 'Learn more about {address} and add homes to application',
      UNIT_PLANNED_BUTTON_LABEL: 'Learn more and join the mailing list',
      YES: 'Ja',
      NO: 'Nej',
      RENT_CHECKBOX_LABEL: 'Show only wealth- and income-limited rental homes.',
      EXTRA_INFO_1: 'Priserna är uppskattningar tills vidare.',
      EXTRA_INFO_2:
        'This is a new property, which is not yet for sale. Join the mailing list for this house, and you will receive information when the application period begins.',
      GO_TO_APPLICATION_LABEL: 'Gå till din ansökan',
      READ_MORE: 'Läs mer',
      ZERO_RESULTS:
        'Your search did not find any homes that are currently available or about to be available.',
      SEARCH_BUTTON_TITLE:
        'The button for finding apartments is inactive until you have made a filtering selection in the search.',
      KERROSTALO: 'Lägenhetstyp',
      RIVITALO: 'Radhus',
      OMAKOTITALO: 'Fristående hus',
      PARITALO: 'Parhus',
      ERILLISTALO: 'Fristående hus',
      LUHTIKYTVTALO: 'Loftgångshus',
      PIENKERROSTALO: 'Låghus',
      CALL_NOW: 'Ring nu',
    },
    en: {
      SUBMIT_LABEL: 'Show homes ({amount})',
      TAB_1: 'Right-of-occupancy homes',
      TAB_2: 'Rental homes',
      TAB_3: 'Owner-occupied homes',
      MULTISELECT_LABEL: 'Location',
      MULTISELECT_PLACEHOLDER: 'City, district, postal code, address',
      AREA_LABEL: 'Area',
      USAGE_FEE_MAX_LABEL: 'Residence charge max',
      RENT_FEE_MAX_LABEL: 'Rent max',
      EURO_MONTH: '€ / month',
      BUILDING_TYPE_LABEL: 'Housing type',
      ROOMS_LABEL: 'Rooms',
      DETAILED_SEARCH_LABEL: 'Features',
      TOGGLE_MORE: 'More search rules',
      TOGGLE_LESS: 'Less search rules',
      AVAILABLE_LATEST: 'Available latest',
      FOUND_AVAILABLE_TITLE:
        '{amount} available or soon to be available homes found.',
      FOUND_AVAILABLE_TITLE_CITY:
        '{amount} available or soon to be available homes found in {city}.',
      SORT_PLACEHOLDER: 'Sort by',
      SORT_BY_OPTION_1: 'Smallest first',
      SORT_BY_OPTION_2: 'Largest first',
      SORT_BY_OPTION_3: 'Least expensive first',
      SORT_BY_OPTION_4: 'Most expensive first',
      SORT_BY_OPTION_5: 'Lowest residence charge/month',
      FOUND_UNIT_RESULTS_TITLE:
        '{amountApartments} matching homes in {amountUnits} houses',
      FOUND_UNIT_RESULTS_DESCRIPTION:
        'These buildings are matching to your search criteria, but there may not be available homes at the moment. However, you can also add buildings with no available homes to your application, and when apartments that match your application become available, you will be automatically included in the application process for the following types of home.',
      APARTMENT_VALUES_LABEL_1: 'Residence charge / month',
      APARTMENT_VALUES_LABEL_1_RENT: 'Rent / month',
      APARTMENT_VALUES_LABEL_2: 'Right-of-occupancy payment',
      APARTMENT_VALUES_LABEL_2_RENT: 'Asset limits',
      APARTMENT_VALUES_LABEL_3_RENT: 'Income limits',
      APARTMENT_VALUES_LABEL_3: 'Construction year',
      APARTMENT_VALUES_LABEL_4: 'Floor',
      APARTMENT_VALUES_LABEL_5: 'Available',
      APARTMENT_VALUES_LABEL_6: 'Next viewing',
      APARTMENT_STATUS_LABEL: 'New property',
      APARTMENT_AVAILABLE_LABEL: 'Available now',
      APARTMENT_AVAILABLE_UNKNOWN: 'Specified later',
      APARTMENT_NEW_AND_AVAILABLE: 'New property, available now',
      APARTMENT_NEW_AND_IN_CONSTRUCTION: 'New property, under construction',
      APARTMENT_RENOVATED_AND_AVAILABLE: 'Renovated, available now',
      APARTMENT_RENOVATED: 'Renovated',
      APARTMENT_IS_PLANNED: 'New property, coming soon',
      APARTMENT_MORE_LINK_LABEL: 'More details',
      APARTMENT_ADD_LABEL: 'Add to application',
      APARTMENT_REMOVE_LABEL: 'Remove from application',
      LOAD_MORE: 'More homes',
      UNIT_VALUES_LABEL_1: 'Residence charge/month',
      UNIT_VALUES_LABEL_2: 'Right-of-occupancy payment (avg.)',
      UNIT_VALUES_LABEL_3: 'Estimated time of completion',
      UNIT_VALUES_LABEL_1_RENT: 'Rent',
      UNIT_TEXT_INFO:
        'You can also add homes to your application, which are not available at the moment.',
      UNIT_MORE_BUTTON_LABEL: 'Learn more and add homes to application',
      UNIT_MORE_BUTTON_ARIA_LABEL: 'Learn more about {address} and add homes to application',
      UNIT_PLANNED_BUTTON_LABEL: 'Learn more and join the mailing list',
      YES: 'Yes',
      NO: 'No',
      RENT_CHECKBOX_LABEL: 'Show only wealth- and income-limited rental homes.',
      EXTRA_INFO_1: 'Prices are estimates for now.',
      EXTRA_INFO_2:
        'This is a new property, which is not yet for sale. Join the mailing list for this house, and you will receive information when the application period begins.',
      GO_TO_APPLICATION_LABEL: 'Go to your application',
      READ_MORE: 'Read more',
      ZERO_RESULTS:
        'Your search did not find any homes that are currently available or about to be available.',
      SEARCH_BUTTON_TITLE:
        'The button for finding apartments is inactive until you have made a filtering selection in the search.',
      KERROSTALO: 'Apartment house',
      RIVITALO: 'Terraced house',
      OMAKOTITALO: 'Detached house',
      PARITALO: 'Duplex',
      ERILLISTALO: 'Detached house',
      ERILLISPIENTALO: 'Detached house',
      LUHTIKYTVTALO: 'Balcony access block',
      PIENKERROSTALO: 'Low-rise apartment house',
      CALL_NOW: 'Call now',
    },
  };

  return strings[lang];
};
